<ion-row class="machine-attribute-details-container">
  <ion-grid>
    <div class="machine-action-flex" *ngIf="!isCloneMode">
      <ion-button class="add-machine-btn" *ngIf="!isEditMachine"
        shape="round" fill="outline" color="primary" (click)="onEdit()">
        {{'Edit'|translate}}
      </ion-button>
      <ng-container *ngIf="isEditMachine">
        <ion-button class="add-machine-btn margin-right-16"
          shape="round" fill="outline" color="primary" (click)="onCancel()">
          {{'Cancel'|translate}}
        </ion-button>
        <ion-button class="add-machine-btn" [disabled]="isSaveDisabled"
          shape="round" fill="outline" color="primary" type="submit" (click)="onSave()">
          {{'Save'|translate}}
        </ion-button>
      </ng-container>
    </div>
    <form class="machine-form-scroll scrollVertical form-height"  #formEle #machineForm="ngForm" ngNativeValidate
      autocomplete="off" *ngIf="isEditMachine">
      <ion-grid class="inp-container" *ngIf="formData && sharedValue?.machineModeList.length">
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'machine_name' | translate }} *</ion-label>
              <ion-item lines=none>
                <ion-input placeholder="{{ 'Enter Machine Name' | translate }}" name="machineName" required
                  [(ngModel)]="formData.machineName" #machineName="ngModel" maxlength="160" (ngModelChange)="onFormChange()">
                </ion-input>
              </ion-item>
              <ion-text class="validate-error" *ngIf="!formData.machineName || formData.machineName.trim() === ''">
                {{ 'required' | translate}}
              </ion-text>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
            <ion-label> {{ 'Customer Name' | translate }} *</ion-label>
            <div>
              <ng-select required [loading]="formData.customerLoading" dropdownPosition="bottom"
                class="cust-name-select placeholder-color" [typeahead]="contactInput$" [bindValue]="'customer_name'"
                (change)="customerSearchByErpId($event)" [bindLabel]="'customer_name'" name="customerName"
                [attr.data-field]="'customerName'"
                [clearable]="true" [items]="contactList |async" [(ngModel)]="formData.customerName"
                #customerName="ngModel" placeholder="{{ 'Search Customer Name' | translate }}" (ngModelChange)="onFormChange()">
              </ng-select>
              <input type="hidden" name="customerId" [(ngModel)]="formData.customerId" #customerId="ngModel" />
              <ion-text class="validate-error"
                *ngIf="!formData.customerName || formData.customerName.trim() === ''">
                {{ 'required' | translate }}
              </ion-text>
            </div>
          </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <div class="label-checkbox-row">
                <ion-label>{{ 'placing_date' | translate }} </ion-label>
                <div class="checkbox-label-container">
                  <input type="checkbox" id="placingDateCheckbox" [checked]="placingDateNotAvailable"
                    (change)="onDateCheckboxToggle($event, 'placingDate')"
                    (keydown.enter)="onDateCheckboxToggleByEnter($event, 'placingDate')"/>
                  <ion-label for="placingDateCheckbox">{{ 'Not Available' | translate }}</ion-label>
                </div>
              </div>
              <ion-item lines="none" class="form-inputs ion-no-padding">
                <div class="app-date-input-with-icon" (click)="!placingDateNotAvailable && placingDateInput.showPicker()">
                  <ion-input class="textInput" type="text" [value]="formData.placingDate ? ((formData.placingDate | date:'dd-MMM-yyyy':'+0000') | lowercase) : ''"
                    readonly></ion-input>
                  <ion-icon name="calendar-outline" class="app-date-input-icon"></ion-icon>
                  <input #placingDateInput class="native-date-picker-hidden" type="date" name="placingDate" [(ngModel)]="formData.placingDate"
                    [disabled]="placingDateNotAvailable" [min]="minDate" (keydown.tab)="onKeydown($event)" (ngModelChange)="onFormChange()">
                </div>
              </ion-item>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'sector/industry' | translate}}</ion-label>
              <ng-select
                [items]="sharedValue?.sectorIndustryList"
                bindLabel="name"
                bindValue="id"
                #sectorIndustry="ngModel"
                name="sectorIndustry"
                [attr.data-field]="'sectorIndustry'"
                [(ngModel)]="formData.sectorIndustry"
                [clearable]="true"
                [searchable]="false"
                (ngModelChange)="onFormChange()"
                placeholder="{{'Select' | translate}}">
              </ng-select>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'location' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input name="location"
                  placeholder="{{ 'enter_location' | translate }}"
                  [(ngModel)]="formData.location" #location="ngModel" (ngModelChange)="onFormChange()">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <div class="label-checkbox-row">
                <ion-label>{{ 'inspection_date' | translate }} *</ion-label>
                <div class="checkbox-label-container">
                  <input type="checkbox" id="inspectionDateCheckbox" [checked]="inspectionDateNotAvailable"
                    (change)="onDateCheckboxToggle($event, 'inspectionDate')"
                    (keydown.enter)="onDateCheckboxToggleByEnter($event, 'inspectionDate')"/>
                  <ion-label for="inspectionDateCheckbox">{{ 'Not Available' | translate }}</ion-label>
                </div>
              </div>
              <ion-item lines="none" class="form-inputs ion-no-padding">
                <div class="app-date-input-with-icon" (click)="!inspectionDateNotAvailable && inspectionDateInput.showPicker()">
                  <ion-input class="textInput" type="text" [value]="formData.inspectionDate ? ((formData.inspectionDate | date:'dd-MMM-yyyy':'+0000') | lowercase) : ''"
                    readonly></ion-input>
                  <ion-icon name="calendar-outline" class="app-date-input-icon"></ion-icon>
                  <input #inspectionDateInput class="native-date-picker-hidden" type="date" name="inspectionDate" #inspectionDate="ngModel" [(ngModel)]="formData.inspectionDate"
                    [disabled]="inspectionDateNotAvailable" required (keydown.tab)="onKeydown($event)" (ngModelChange)="onFormChange()">
                </div>
              </ion-item>
              <ion-text class="validate-error" *ngIf="!inspectionDateNotAvailable && inspectionDate?.invalid && (inspectionDate?.dirty || inspectionDate?.touched || inspectionDate.value === null || inspectionDate.value === '')">
                {{ 'required' | translate}}
              </ion-text>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'certification' | translate }} </ion-label>
              <ion-item lines=none>
                <ion-input name="certification"
                  placeholder="{{ 'enter_certification' | translate }}"
                  [(ngModel)]="formData.certification" #certification="ngModel" (ngModelChange)="onFormChange()">
                </ion-input>
              </ion-item>
            </div>
          </ion-col>
          <ion-col size="6">
            <div class="machine-each-div">
              <ion-label> {{ 'Machine Status' | translate}}</ion-label>
              <ng-select
                [items]="sharedValue?.machineStatusList"
                bindLabel="name"
                bindValue="id"
                #machineStatus="ngModel"
                name="machineStatus"
                [attr.data-field]="'machineStatus'"
                [(ngModel)]="formData.machineStatus"
                [clearable]="true"
                [searchable]="false"
                (ngModelChange)="onFormChange()"
                placeholder="{{'Select' | translate}}">
              </ng-select>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <ion-label> {{ 'Machine Description' | translate }} </ion-label>
            <app-ai-writing-field-shell class="ai-text-area-block" title="Machine Description"
              placeholder="{{'enter_description' | translate}}" name="description" [(ngModel)]="formData.description" (ngModelChange)="onFormChange()"
              fieldContextType="machine-description" [historyKey]="'machine-description::' + machineId"></app-ai-writing-field-shell>
            <ion-text *ngIf="getMachineDescriptionCharacterWarning()" color="warning" class="character-warning">
              {{ getMachineDescriptionCharacterWarning() }}
            </ion-text>
            </ion-col>
        </ion-row>
      </ion-grid>
    </form>
    <ng-container *ngIf="!isEditMachine">
      <ion-grid class="machine-attribute-view-container machine-form-scroll scrollVertical">
        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'machine_name' | translate }} *</ion-label>
            <ion-label class="label-value">{{ formData?.machineName || ('not_available' | translate) }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Customer Name' | translate }} *</ion-label>
            <ion-label class="label-value">{{ formData?.customerName || ('not_available' | translate) }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'placing_date' | translate }} </ion-label>
            <ion-label class="label-value">
              {{ formData?.placingDate?.trim() ? ((formData.placingDate | date:'dd-MMM-yyyy':'+0000') | lowercase) : ('not_available' | translate) }}
            </ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'sector/industry' | translate }}</ion-label>
            <ion-label class="label-value">{{ selectedSectorIndustry }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'location' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.location || ('not_available' | translate) }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'inspection_date' | translate }} *</ion-label>
            <ion-label class="label-value">
              {{ formData?.inspectionDate?.trim() ? ((formData.inspectionDate | date:'dd-MMM-yyyy':'+0000') | lowercase) : ('not_available' | translate) }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'certification' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.certification || ('not_available' | translate) }}</ion-label>
          </ion-col>
          <ion-col size="6">
            <ion-label class="label-title">{{ 'Machine Status' | translate }}</ion-label>
            <ion-label class="label-value">{{ selectedMachineStatus }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <ion-label class="label-title">{{ 'Machine Description' | translate }}</ion-label>
            <ion-label class="label-value">{{ formData?.description || ('not_available' | translate)  }}</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>
  </ion-grid>
</ion-row>